import { useEffect, useState } from 'react';

const TICK_MS = 1000;

function secondsSince(startedAt: number): number {
    return Math.max(0, Math.floor((Date.now() - startedAt) / 1000));
}

export function useElapsedSeconds(
    startedAt: string | number | undefined,
    isActive: boolean
): number | null {
    const [, forceTick] = useState(0);

    useEffect(() => {
        if (!isActive) return;
        const interval = setInterval(() => forceTick((n) => n + 1), TICK_MS);
        return () => clearInterval(interval);
    }, [isActive]);

    if (!isActive || !startedAt) return null;

    const startedAtMs = new Date(startedAt).getTime();
    if (Number.isNaN(startedAtMs)) return null;

    return secondsSince(startedAtMs);
}
